module.exports = {
  envConfig: {
    routerPrefix: "",
    baseURL: "https://partners-qa.threesoft.cn/api",
    epcURL: "https://erp-qa.threesoft.cn"
  }
};
